import { useContext } from "react";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../../routing/LangRouter";

//import utils
import { formatGregorianDate, formatPersianDate } from "../../../../utils/date";

//import general components
import TicketArrow from "../../../common/ticket-arrow/ticket-arrow";

//import image
import AirplaneSvg from "../../../../assets/icons/airplane.svg";

export function IntOrderContent({ title, information, isReturn }) {
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    return (
        <Grid container item xs={12} rowGap={1}>
            {isReturn && (
                <Grid className="orders__flight-type" container item xs="auto">
                    {title}
                </Grid>
            )}

            <Grid container item xs={12} columnGap={{ xs: 1, md: 2 }}>
                <Grid container item xs="auto" direction="column" rowGap={1}>
                    <Grid container columnGap={1}>
                        {information.map(segment => {
                            return <img key={Math.random()} className="orders__int-airline-image" src={segment?.airline?.image} />;
                        })}
                    </Grid>
                    <Grid className="orders__airline-name" component="span" container item xs="auto">
                        {t("severalAirlines")}
                    </Grid>
                </Grid>

                <Grid container item xs={8} rowGap={2}>
                    <Grid container item xs={12} columnGap={{ xs: 1, md: 2 }} alignItems="center">
                        <span className="orders__departure">
                            {["fa", "ar"].includes(locale) ? information?.[0]?.departure?.city?.persian : information?.[0]?.departure?.city?.english}{" "}
                        </span>
                        <TicketArrow list={information} icon={<img src={AirplaneSvg} />} />
                        <span className="orders__departure">
                            {["fa", "ar"].includes(locale)
                                ? information?.[information.length - 1]?.destination?.city?.persian
                                : information?.[information.length - 1]?.destination?.city?.english}
                        </span>
                    </Grid>

                    <Grid container item xs={12} columnGap={1}>
                        <Grid container display={{ xs: "none", md: "flex" }}>
                            {t("departureTimeDate")}:
                        </Grid>
                        <span className="orders__date-time">
                            {locale === "fa"
                                ? `${formatPersianDate(information?.[0]?.departure_date, {
                                      day: "numeric",
                                      month: "long",
                                      year: "numeric",
                                      weekday: undefined,
                                  })}
                                 - ${information?.[0].departure_time.split(":", 2).join(":")}`
                                : formatGregorianDate(information?.[0]?.departure_date, null, "YYYY/MM/DD") +
                                  " - " +
                                  information?.[0].departure_time.split(":", 2).join(":")}
                        </span>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

function IntFlightOrder({ order }) {
    const { t } = useTranslation();
    return (
        <Grid container item xs={12} rowGap={2}>
            {!!order?.segments?.length && (
                <IntOrderContent title={t("departureFlight")} information={order?.segments} isReturn={!!order?.return_segments?.length} />
            )}
            {!!order?.return_segments?.length && (
                <IntOrderContent title={t("returnFlight")} information={order?.return_segments} isReturn={!!order?.return_segments?.length} />
            )}
        </Grid>
    );
}

export default IntFlightOrder;
